import { render, staticRenderFns } from "./workClothesOrder.vue?vue&type=template&id=fd6a8098"
import script from "./workClothesOrder.vue?vue&type=script&lang=js"
export * from "./workClothesOrder.vue?vue&type=script&lang=js"
import style0 from "./workClothesOrder.vue?vue&type=style&index=0&id=fd6a8098&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports